export const EmptyGroupKey: string = 'X';
